(function (window, $j) {

    function onDocReady() {
        if($j(".real-meetings-container").length) {
            if (!$j(".real-meetings-bottom-container").length) {
                $j(".real-meetings-container .show-more-meetings-button").hide();
            } else {
                $j(".real-meetings-container .show-more-meetings-button").click(toggleMeetings);
            }
        }
    }

    function toggleMeetings() {
        var container = $j(this).closest(".real-meetings-container");
        var moreContainer = container.find(".real-meetings-bottom-container");

        if(moreContainer.hasClass("show-more")) {
            moreContainer.slideUp();
            moreContainer.removeClass("show-more");
            $j(this).html($j(this).attr("data-open-button"));
        }
        else {
            moreContainer.slideDown();
            moreContainer.addClass("show-more");
            $j(this).html($j(this).attr("data-close-button"));
        }
    }

    $j(onDocReady);

    return {};

})(window,$j);